var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkBoldIcon = function SvgCheckmarkBoldIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.554 1.032c.482.34.589 1 .245 1.476L8.015 18.728a1.06 1.06 0 0 1-.781.436 1.1 1.1 0 0 1-.849-.304l-6.07-5.994a1.044 1.044 0 0 1 0-1.495 1.08 1.08 0 0 1 1.513 0L7.01 16.48 18.058 1.274a1.08 1.08 0 0 1 1.495-.242"
  })));
};
export default SvgCheckmarkBoldIcon;